<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0">
                <a href="javascript:void(0);" routerLink="/salestarget/sales-target-list"><span
                        class="mdi mdi-arrow-left"></span></a>
                Details Sales Target
            </h4>
        </div>

        <div class="card">
            <div class="card-body new-detail-page">
                <div class="d-flex align-items-center">
                    <p class="mb-0">Financial Year</p>
                    <p class="mb-0 ml-2">{{FinanceYear}}</p>
                </div>
                <form>
                    <div class="form-row mt-0">
                        <div class="col-md-12 mt-2">
                            <div class="table-responsive mt-1">
                                <table class="table" mat-table [dataSource]="ProductDataSource"
                                    [multiTemplateDataRows]="true" aria-hidden="true">
                                    <ng-container matColumnDef="BusinessCategoryName">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Sal Eng. Nam
                                        </th>
                                        <div matColumnDef="Total">
                                            <td mat-header-cell *matHeaderCellDef [attr.colspan]="1"
                                                class="text-right ali font-w">
                                                Total
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element">
                                            {{ element["SalesEngineer"] }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="ProductBrandName">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Booking Tr Val
                                        </th>
                                        <div matColumnDef="BookingValue">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalBookingTarget | number : "1.2-2"}}
                                                </span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            {{ element["BookingTarget"] | number : "1.2-2"}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Origin">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Billing Tr Val
                                        </th>
                                        <div matColumnDef="BillingValue">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalBillingTarget | number : "1.2-2"}}
                                                </span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            {{ element["BillingTarget"] | number : "1.2-2"}}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Code">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Jan
                                        </th>
                                        <div matColumnDef="TotalJan">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalJanTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalJanAchieved < TotalRow?.TotalJanTarget ? 'red' : 'green'}">{{TotalRow?.TotalJanAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span> {{ element["JanTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.JanAchieved < element.JanTarget ? 'red' : 'green'}">{{
                                                element["JanAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Description">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Feb
                                        </th>
                                        <div matColumnDef="TotalFeb">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalFebTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalFebAchieved < TotalRow?.TotalFebTarget ? 'red' : 'green'}">{{TotalRow?.TotalFebAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span> {{ element["FebTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.FebAchieved < element.FebTarget ? 'red' : 'green'}">{{
                                                element["FebAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Specified">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Mar
                                        </th>
                                        <div matColumnDef="TotalMar">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalMarTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalMarAchieved < TotalRow?.TotalMarTarget ? 'red' : 'green'}">{{TotalRow?.TotalMarAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["MarTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.MarAchieved < element.MarTarget ? 'red' : 'green'}">{{
                                                element["MarAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Qty">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Apr
                                        </th>
                                        <div matColumnDef="TotalApr">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalAprTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalAprAchieved < TotalRow?.TotalAprTarget ? 'red' : 'green'}">{{TotalRow?.TotalAprAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["AprTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.AprAchieved < element.AprTarget ? 'red' : 'green'}">{{
                                                element["AprAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="UnitType">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            May
                                        </th>
                                        <div matColumnDef="TotalMay">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalMayTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalMayAchieved < TotalRow?.TotalMayTarget ? 'red' : 'green'}">{{TotalRow?.TotalMayAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["MayTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.MayAchieved < element.MayTarget ? 'red' : 'green'}">{{
                                                element["MayAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Price">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Jun
                                        </th>
                                        <div matColumnDef="TotalJun">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalJunTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalJunAchieved < TotalRow?.TotalJunTarget ? 'red' : 'green'}">{{TotalRow?.TotalJunAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["JunTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.JunAchieved < element.JunTarget ? 'red' : 'green'}">{{
                                                element["JunAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="GrossValue">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Jul
                                        </th>
                                        <div matColumnDef="TotalJul">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalJulTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalJulAchieved < TotalRow?.TotalJulTarget ? 'red' : 'green'}">{{TotalRow?.TotalJulAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["JulTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.JulAchieved < element.JulTarget ? 'red' : 'green'}">{{
                                                element["JulAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="DiscountPer">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Aug
                                        </th>
                                        <div matColumnDef="TotalAug">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalAugTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalAugAchieved < TotalRow?.TotalAugTarget ? 'red' : 'green'}">{{TotalRow?.TotalAugAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["AugTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.AugAchieved < element.AugTarget ? 'red' : 'green'}">{{
                                                element["AugAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="TotalPrice">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Sep
                                        </th>
                                        <div matColumnDef="TotalSep">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalSepTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalSepAchieved < TotalRow?.TotalSepTarget ? 'red' : 'green'}">{{TotalRow?.TotalSepAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["SepTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.SepAchieved < element.SepTarget ? 'red' : 'green'}">{{
                                                element["SepAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="VatRate">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Oct
                                        </th>
                                        <div matColumnDef="TotalOct">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalOctTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalOctAchieved < TotalRow?.TotalOctTarget ? 'red' : 'green'}">{{TotalRow?.TotalOctAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["OctTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.OctAchieved < element.OctTarget ? 'red' : 'green'}">{{
                                                element["OctAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="TotalPriceWithVat">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Nov
                                        </th>
                                        <div matColumnDef="TotalNov">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalNovTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalNovAchieved < TotalRow?.TotalNovTarget ? 'red' : 'green'}">{{TotalRow?.TotalNovAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["NovTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.NovAchieved < element.NovTarget ? 'red' : 'green'}">{{
                                                element["NovAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="Competitor">
                                        <th mat-header-cell *matHeaderCellDef class="width-90-small">
                                            Dec
                                        </th>
                                        <div matColumnDef="TotalDec">
                                            <td mat-header-cell *matHeaderCellDef class="text-right p-1 font-12 font-w">
                                                <span>{{TotalRow?.TotalDecTarget | number : "1.2-2"}}
                                                </span><br>
                                                <span
                                                    [ngStyle]="{'color': TotalRow?.TotalDecAchieved < TotalRow?.TotalDecTarget ? 'red' : 'green'}">{{TotalRow?.TotalDecAchieved
                                                    | number : "1.2-2"}}</span>
                                            </td>
                                        </div>
                                        <td mat-cell *matCellDef="let element" class="text-right p-1 font-12">
                                            <span>{{ element["DecTarget"] | number : "1.2-2"}}</span><br>
                                            <span
                                                [ngStyle]="{'color': element.DecAchieved < element.DecTarget ? 'red' : 'green'}">{{
                                                element["DecAchieved"] | number : "1.2-2"}}</span>
                                        </td>
                                    </ng-container>

                                    <tr class="odd" mat-header-row *matHeaderRowDef="displayedProductColumns"></tr>
                                    <tr class="even" mat-header-row *matHeaderRowDef="displayedTotalColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedProductColumns"></tr>
                                </table>
                                <div *ngIf="TotalProductRecord == 0" class="text-center">
                                    No Record found.
                                </div>
                                <div *ngIf="TotalProductRecord > 0">
                                    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]"
                                        [length]="totalProductSize" showFirstLastButtons
                                        aria-label="Select page of periodic elements" [pageIndex]="currentPage"
                                        (page)="ProducthandlePage($event)" [pageSize]="pageSize">
                                    </mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ng-template #downloadConfirm>
    <div class="modal-body text-center">
        <p>Do you want to Download {{filename}} ?</p>
        <button type="button" class="btn btn-info btn-sm" (click)="download(); modalRef.hide();"
            [disabled]="delNameDel">Download</button>
        <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline()">Cancel</button>
    </div>
</ng-template>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>